import "./TheHolodeck.module.css";
import NexusHeader from "@/reusable_sections/Header";
import VictoryClips from "./sections/VictoryClips";
import TheArmory from "./sections/TheArmory";
import FanFeedback from "./sections/FanFeedback";
import NexusFooter from "@/reusable_sections/Footer";
export default function TheHolodeckPage() {
  return <div>
      <NexusHeader />
      <VictoryClips />
      <TheArmory />
      <FanFeedback />
      <NexusFooter />
    </div>;
}